<form *ngIf="workerRateFormGroup" [formGroup]="workerRateFormGroup">
    <div class="grid">
        <div class="col-12 input-field">
            <label for="rateId">Baremo *</label>
            <p-dropdown [options]="rates" formControlName="rateId" optionValue="id" [filter]="true" filterBy="name"
                optionLabel="name" placeholder="Seleccione baremo" appendTo="body" d-form-field-error />
        </div>
        <div class="col-6 input-field">
            <label for="normalServiceAllowed" class="mr-1">Horario normal</label>
            <p-inputSwitch id="normalServiceAllowed" formControlName="normalServiceAllowed"></p-inputSwitch>
        </div>
        <div class="col-6 input-field">
            <label for="guardServiceAllowed" class="mr-1">Horario de guardia</label>
            <p-inputSwitch id="guardServiceAllowed" formControlName="guardServiceAllowed"></p-inputSwitch>
        </div>
    </div>

    <div class="mt-4 flex gap-2 justify-content-end">
        <p-button label="Eliminar" *ngIf="allowDelete && workerRate.id" icon="pi pi-trash"
            styleClass="p-button-danger" (click)="delete()"></p-button>
        <div class="flex-grow-1"></div>
        <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
        <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
    </div>

</form>